// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/activity/v1/activity.proto (package gdx.activity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * Enumerates all possible activities types for filtering.
 *
 * @generated from enum gdx.activity.v1.ActivityType
 */
export enum ActivityType {
  /**
   * @generated from enum value: ACTIVITY_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: ACTIVITY_TYPE_VISIT = 1;
   */
  VISIT = 1,

  /**
   * @generated from enum value: ACTIVITY_TYPE_LIKE = 2;
   */
  LIKE = 2,

  /**
   * @generated from enum value: ACTIVITY_TYPE_UNMATCH = 3;
   */
  UNMATCH = 3,

  /**
   * @generated from enum value: ACTIVITY_TYPE_REQUEST_PHOTO = 4;
   */
  REQUEST_PHOTO = 4,

  /**
   * @generated from enum value: ACTIVITY_TYPE_REQUEST_PHOTO_UPLOADED = 5;
   */
  REQUEST_PHOTO_UPLOADED = 5,

  /**
   * @generated from enum value: ACTIVITY_TYPE_ZODIAC_COMPATIBILITY = 6;
   */
  ZODIAC_COMPATIBILITY = 6,

  /**
   * @generated from enum value: ACTIVITY_TYPE_POWER_LIKE = 7;
   */
  POWER_LIKE = 7,

  /**
   * @generated from enum value: ACTIVITY_TYPE_SEXUAL_COMPATIBILITY = 8;
   */
  SEXUAL_COMPATIBILITY = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(ActivityType)
proto3.util.setEnumType(ActivityType, "gdx.activity.v1.ActivityType", [
  { no: 0, name: "ACTIVITY_TYPE_INVALID" },
  { no: 1, name: "ACTIVITY_TYPE_VISIT" },
  { no: 2, name: "ACTIVITY_TYPE_LIKE" },
  { no: 3, name: "ACTIVITY_TYPE_UNMATCH" },
  { no: 4, name: "ACTIVITY_TYPE_REQUEST_PHOTO" },
  { no: 5, name: "ACTIVITY_TYPE_REQUEST_PHOTO_UPLOADED" },
  { no: 6, name: "ACTIVITY_TYPE_ZODIAC_COMPATIBILITY" },
  { no: 7, name: "ACTIVITY_TYPE_POWER_LIKE" },
  { no: 8, name: "ACTIVITY_TYPE_SEXUAL_COMPATIBILITY" },
]);

